module.exports = __webpack_public_path__ + "static/media/achievement-tier-0.0a63c8b1.svg";